import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "cropper-component",
  components: { VueCropper },
  data() {
    return {
      isModalOpen: false
    };
  },
  props: {
    file: {
      type: File
    }
  },
  computed: {
    url() {
      if (this.file) return URL.createObjectURL(this.file);
    }
  },
  methods: {
    openEditModal() {
      this.isModalOpen = true;
    },
    closeEditModal() {
      this.isModalOpen = false;
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute("data-scale", scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    confirm() {
      // console.log(this.$refs.cropper.getCroppedCanvas().toDataURL());
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        this.$emit("onUpdateImage", blob);
      });

      this.closeEditModal();
    },
    onReady(data) {
      console.log("onready", data);
    }
  }
};
